import {bootstrapApplication} from '@angular/platform-browser';
import {datadogRum} from '@datadog/browser-rum';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {runInInjectionContext} from '@angular/core';
import {DatadogService} from './app/shared/services/datadog.service';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const injector = appRef.injector;
    runInInjectionContext(injector, () => {
      injector.get(DatadogService).init();
    });
  })
  .catch((err) => {
    datadogRum.addError(err);
    console.error(err);
  });
